export default __webpack_public_path__ + "static/media/plus.f2e645f4.svg";